// Whether saving this visit on Schedule & Dispatch should also move it to Scheduled.
// Requires the dispatcher's "set visit status to Scheduled" toggle, a change of assignee, and a
// status that opts in: Pending always does, a custom inspection status only when the tenant has
// turned on "Move to Scheduled when assigned" for it.
export default function shouldScheduleOnAssignment(enabled, visit, originalState) {
    if (!enabled)
        return false;
    if (visit.assignee.key === (originalState === null || originalState === void 0 ? void 0 : originalState.assignee.key))
        return false;
    return visit.status.key === 'pending' || visit.status.scheduleOnAssignment === true;
}
